import classnames from "classnames";
import {Col, Nav, NavItem, NavLink, Row} from "reactstrap";
import React from "react";
import PropTypes from "prop-types";
import "./index.css"

const ProfileTabComponent = (props) => {

    const publishedContentClassNames = classnames({
        active: props.activeTab === "published_content",
        "cursor-pointer": true
    });

    const followersClassNames = classnames({
        active: props.activeTab === "followers",
        "cursor-pointer": true
    });

    const subscriptionClassNames = classnames({
        active: props.activeTab === "subscriptions",
        "cursor-pointer": true
    });

    const subscribersClassNames = classnames({
        active: props.activeTab === "subscribers",
        "cursor-pointer": true
    });

    const aboutClassNames = classnames({
        active: props.activeTab === "about",
        "cursor-pointer": true
    });

    return (
        <Row className={"profile-tab-component-container"}>
            <Col md="12">
                <Nav tabs className="availability-requests">
                    <NavItem className="ml-md-3">
                        <NavLink
                            className={publishedContentClassNames}
                            onClick={() => props.toggle("published_content")}>
                            PUBLISHED CONTENT
                        </NavLink>
                    </NavItem>
                    {/*<NavItem className="ml-md-3">*/}
                    {/*    <NavLink*/}
                    {/*        className={followersClassNames}*/}
                    {/*        onClick={() => props.toggle("followers")}>*/}
                    {/*        FOLLOWERS*/}
                    {/*    </NavLink>*/}
                    {/*</NavItem>*/}
                    {
                        props.isBroadcastersOwnPage &&
                        <NavItem className="ml-md-3">
                            <NavLink
                                className={subscriptionClassNames}
                                onClick={() => props.toggle("subscriptions")}>
                                SUBSCRIPTIONS
                            </NavLink>
                        </NavItem>
                    }
                    {
                        props.isBroadcastersOwnPage &&
                        <NavItem className="ml-md-3">
                            <NavLink
                                className={subscribersClassNames}
                                onClick={() => props.toggle("subscribers")}>
                                SUBSCRIBERS
                            </NavLink>
                        </NavItem>
                    }
                    <NavItem className="ml-md-3">
                        <NavLink
                            className={aboutClassNames}
                            onClick={() => props.toggle("about")}>
                            ABOUT
                        </NavLink>
                    </NavItem>
                </Nav>
            </Col>
        </Row>
    )
};

ProfileTabComponent.propTypes = {
    activeTab: PropTypes.string.isRequired,
    toggle: PropTypes.func.isRequired,
    isBroadcastersOwnPage:PropTypes.bool.isRequired,
};


export default ProfileTabComponent;